import { default as React, useContext, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Factory } from '@mui/icons-material'
import ListManufacturers from './ListManufacturers'
import ListViewCommandBar from '../commandBar/ListViewCommandBar'
import Page from '../layout/Page'
import { ROLES } from '../auth/role'
import RoleContext from '../auth/RoleContext'
import { Paper } from '@mui/material'
import TabPanel from '../form/TabPanel'
import { useLocalStorage } from '../utils/ReactUtils'

export default function ListManufacturersPage (props = {}) {
  const roleDetails = useContext(RoleContext)
  const [isLoading, setIsLoading] = useState(true)
  const navigate = useNavigate()
  const [selectedTab, setSelectedTab] = useState(0)
  const [searchParams, setSearchParams] = useSearchParams({ view: 'active', page: '1'})

  const tabChange = (event, toTab) => {
    setSearchParams({view: toTab === 1 ? 'inactive' : 'active'})
  }

  const startLoading = () => {
    setIsLoading(true)
  }

  const stopLoading = () => {
    setIsLoading(false)
  }

  const breadcrumb = <span><Factory/>&nbsp;Facilities</span>

  const [showFilters, setShowFilters] = useLocalStorage("showFilters", false)
  const toggleFilters = () => {
    setShowFilters(!showFilters);
  }
  // const [showFilters, setShowFilters] = useState(localStorage.getItem("showFilters") === "true")
  // const toggleFilters = () => {
  //   const _showFilters = !showFilters
  //   if (_showFilters) {
  //     localStorage.setItem("showFilters", "true")
  //   } else {
  //     localStorage.removeItem("showFilters")
  //   }
  //   setShowFilters(_showFilters)
  // }

  const addRecord = () => {
    navigate('/manufacturer/create')
  }

  useEffect(() => {
    setSelectedTab(searchParams.get('view') === 'inactive' ? 1 : 0)
  }, [searchParams])

  return (
    <Page { ...props} breadcrumb={breadcrumb} isLoading={isLoading} 
    commandBar={
      <ListViewCommandBar 
        showFilters={true}
        filtersEnabled={showFilters}
        toggleFilters={toggleFilters} 
        addRecord={addRecord} 
        showAdd={roleDetails.isQualityManager() || roleDetails.isImManager()}
      />
    }>
      <Paper sx={{margin: '0 auto 1em auto' }}>
        { (roleDetails.isInternalUser() || roleDetails.hasRole([ROLES.IM_MANAGER])) && 
          
          <TabPanel panelId='facilities' key='facilities' tabs={[
            {
              key: 'active',
              label: 'Active',
              el: (
              <ListManufacturers showFilters={showFilters} startLoading={startLoading} stopLoading={stopLoading} searchFilter={{isActive: true}}/>
              )
            },
            {
              key: 'inactive',
              label: 'Inactive',
              el: (
                <ListManufacturers showFilters={showFilters} startLoading={startLoading} stopLoading={stopLoading} searchFilter={{isActive: false}}/>
              )
            }
          ]} tabStyle={{ textTransform: 'none', minHeight: 'unset'}}
            defaultTab={selectedTab}
            onTabChange={(idx) => tabChange(null, idx)}
          />
          
        }
        { roleDetails.isBottlerUser() && 
          <ListManufacturers showFilters={showFilters} startLoading={startLoading} stopLoading={stopLoading} searchFilter={{isActive: true}}/>
        }
      </Paper>
  </Page>
  )
}